import { render, staticRenderFns } from "./FormTime.vue?vue&type=template&id=2980a755&"
import script from "./FormTime.vue?vue&type=script&lang=js&"
export * from "./FormTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports